import { useEffect, useRef, useState } from 'react';

export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  // Keyed on content: callers pass a fresh array every render, and keying on the
  // reference let any re-render inside the delay cancel the pending update for good.
  const serialized = JSON.stringify(value);
  const debouncedSerialized = useRef(serialized);

  useEffect(() => {
    if (serialized === debouncedSerialized.current) return;
    const handler = setTimeout(() => {
      debouncedSerialized.current = serialized;
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `serialized` is `value`'s content
  }, [serialized, delay]);

  return debouncedValue;
}
